import { ComponentProps, FC } from 'react';
import { Input } from '@shared/shared-shadcn-ui';
import { cn } from '@shared/shared-utils';
import { sendFormFieldInteractionEvent } from '@shared/shared-gtm-tracker';

type Properties = ComponentProps<'input'>;

const FormInput: FC<Properties> = (props: Properties) => {
  return (
    <Input
      {...props}
      className={cn(
        'bg-white rounded-[6px] !text-[18px] lg:!text-[20px] py-7 leading-[23px] font-bold text-[#1C1C1C] border-[rgba(0,_0,_0,0.12)]',
        props.className,
      )}
      onBlur={sendFormFieldInteractionEvent}
    />
  );
};

export { FormInput };
